export const queueMacrotask = (task: (arg?: any) => void) => {
  window.setTimeout(task, 0);
};
